module.exports = __webpack_public_path__ + "static/media/foto4.be4975bd.png";